module.exports = __webpack_public_path__ + "static/AdobeStock_261530621_Preview-original-094a7822b07f1f77810bb785ece7af7e.jpg";